import { AnimatePresence, motion } from 'motion/react';

const prefersReducedMotion =
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;

const CUTOUT_PADDING = 8;

function buildClipPath(rect: DOMRect): string {
  const left = rect.left - CUTOUT_PADDING;
  const top = rect.top - CUTOUT_PADDING;
  const right = rect.right + CUTOUT_PADDING;
  const bottom = rect.bottom + CUTOUT_PADDING;

  return `polygon(
    0% 0%, 0% 100%,
    ${left}px 100%, ${left}px ${top}px,
    ${right}px ${top}px, ${right}px ${bottom}px,
    ${left}px ${bottom}px, ${left}px 100%,
    100% 100%, 100% 0%
  )`;
}

export interface ContextualSpotlightProps {
  targetRect: DOMRect | null;
  visible: boolean;
}

export function ContextualSpotlight({ targetRect, visible }: ContextualSpotlightProps) {
  const show = visible && targetRect !== null;
  const fadeDuration = prefersReducedMotion ? 0 : 0.2;

  return (
    <AnimatePresence>
      {show ? (
        <motion.div
          key="contextual-spotlight-overlay"
          aria-hidden="true"
          data-testid="contextual-spotlight"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: fadeDuration }}
          className="pointer-events-none fixed inset-0 z-50 bg-black/60"
          style={{
            clipPath: buildClipPath(targetRect),
            transition: `clip-path 300ms ease-in-out`,
          }}
        />
      ) : null}
    </AnimatePresence>
  );
}
